import { parseHostname } from '@ta-interaktiv/parse-hostname'

type Cantons = 'ZH' | 'BE' | 'VD' | 'GE' | 'BA'

export const useGetCanton = () => {
  const publicationName = parseHostname().publicationName
  const cantons: Map<string, Cantons> = new Map([
    ['24heures', 'VD'],
    ['tdg', 'GE'],
    ['bernerzeitung', 'BE'],
    ['derbund', 'BE'],
    ['berneroberlaender', 'BE'],
    ['langenthalertagblatt', 'BE'],
    ['thunertagblatt', 'BE'],
    ['bazonline', 'BA'],
    ['tagesanzeiger', 'ZH'],
    ['zsz', 'ZH'],
    ['zuonline', 'ZH'],
    ['landbote', 'ZH']
  ])

  return cantons.get(publicationName) || 'ZH'
}
